import Image from "next/image";
import { FC } from "react";

import GoldenGate from "../../public/webstatic/images/golden-gate.jpg";

export const CompanyBackground: FC = () => {
  return (
    <>
      <div className="grid grid-cols-[auto_minmax(0,86rem)_auto] grid-rows-[auto_auto_0]">
        <div className="">{/* empty */}</div>
        <div className="dotted-v lg:mx-12 lg:border-x">
          <div className="flex h-full w-full flex-col items-center gap-6 px-6 py-16 lg:flex-row lg:gap-14 lg:px-14">
            <div className="flex flex-1 flex-col gap-4">
              <h2 className="text-[32px] lg:text-[40px]">About Frec</h2>
              <p className=" ">
                Frec was founded in 2021 and is based out of San Francisco.
                We’re funded by a long list of incredible investors from
                companies like Google, Meta, Brex, and more. Our biggest backer
                is Greylock. Frec has two subsidiaries: one is an SEC registered
                investment adviser and the other is an SEC registered broker
                dealer and FINRA member. Assets are housed at Apex Clearing
                House.
              </p>
            </div>
            <div className="flex-1">
              <Image
                src={GoldenGate}
                className="cover w-full"
                alt="Golden gate bridge"
              />
            </div>
          </div>
        </div>
        <div className="dotted-h col-span-3 border-b">{/*empty*/}</div>
      </div>
    </>
  );
};
